import tw from 'twin.macro';

const Image = tw.img`object-cover`;

export default Image;
